const { conversationId } = require('../app.config')
const { tenantHash } = require('@/app.config')
const { getWithExpiry } = require('@/helpers/sessionStorage')
const firstLetterCapitalize = input => {
  return input.toLowerCase().replace(/\b\w/g, item => {
    return item.toUpperCase()
  })
}

const getSessionId = state => {
  let sessionId
  if (state) {
    sessionId = state.socket.sessionId
    if (
      state.isUserLoggedIn &&
      state.userInfo.sub &&
      !global.keycloak.hasRealmRole('dashboard-access')
    ) {
      sessionId = `${state.userInfo.sub}-${state.language}`
    }
  }
  const storageSessionId = getWithExpiry('currentSession', tenantHash)
  if (storageSessionId) {
    sessionId = storageSessionId
  }
  if (conversationId) {
    sessionId = conversationId.trim()
  }
  return sessionId !== null ? `${sessionId}` : null
}

module.exports = {
  firstLetterCapitalize,
  getSessionId
}
